<template>
  <div
    v-if="tips"
    :class="b()"
  >
    <component :is="tips" />

    <div
      v-if="hasSystemMemberEditPermission || showUpgradeBtn"
      class="btn-group"
    >
      <el-button
        v-if="hasSystemMemberEditPermission"
        :class="b('btn')"
        type="primary"
        plain
        @click="handleRouterToSetting"
      >
        {{ $t('saas.UserUpdateTIps.removeOrDisabled') }}
      </el-button>
      <template v-if="showUpgradeBtn">
        <el-button
          v-if="isFree"
          :class="b('btn')"
          type="primary"
          @click="handleRouterToBuy"
        >
          {{ $t('saas.UserUpdateTIps.update') }}
        </el-button>
        <el-button
          v-else
          type="primary"
          :class="b('btn')"
          @click="handleRouterToBuy"
        >
          {{ $t('saas.UserUpdateTIps.buy') }}
        </el-button>
      </template>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import theme from '@zk/theme/lib/variables.scss';
import { mapGetters } from 'vuex';
import { resolveUrl } from '@zk/framework-vue';
import * as permission from 'common-module/src/config/permission';

export default {
  name: 'UserUpdateTips',
  props: {
    activeComponents: {
      type: String,
      default: ''
    },
    needBuyCount: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      bemNS: theme.bemNS,
      subDialogVisible: false
    };
  },
  computed: {
    ...mapGetters('user', ['getMemberNum', 'userProductRights', 'checkAccessPermission']),
    ...mapGetters(['allRoles']),
    hasUpgradePermission() {
      return this.checkAccessPermission(permission.upgrade);
    },
    hasSystemMemberEditPermission() {
      return this.checkAccessPermission(permission.settingMemberEdit);
    },
    isFree() {
      return this.userProductRights?.productSchemeVO?.schemeType === 0 || this.userProductRights?.productSchemeVO?.schemeType === 1;
    },
    showUpgradeBtn() {
      return !this.isPrivateVersion && !this.$store.getters.isAWSUserMark && this.hasUpgradePermission;
    },
    isEmailInvite() {
      return this.activeComponents === 'inviteEmail';
    },
    isDirectAdd() {
      return this.activeComponents === 'inviteDirectAdd';
    },
    isOtherInvite() {
      return !this.isEmailInvite && !this.isDirectAdd;
    },
    tips() {
      const h = this.$createElement;
      const createI18nComponent = (path, { attrs, children } = {}) => {
        return Vue.extend({
          render: () => h('i18n', {
            props: {
              path,
              tag: 'span',
              ...(attrs?.props || {})
            },
            attrs: {
              class: this.b('desc'),
              ...(attrs || {})
            }
          }, children)
        });
      };
      const cfg = [{
        condition: !this.hasUpgradePermission && !this.hasSystemMemberEditPermission && this.noSeatsAvailable,
        component: createI18nComponent('saas.UserUpdateTips.desc4', {
          children: [
            h('span', this.$t('saas.UserUpdateTips.desc4'))
          ]
        })
      }, {
        condition: this.isEmailInvite && this.sufficientSeatsAvailable,
        component: createI18nComponent('saas.UserUpdateTips.desc5', {
          children: [
            h('span', { attrs: { place: 'number1' } }, this.getMemberNum.totalNum - this.getMemberNum.usedNum - this.needBuyCount),
            h('span', { attrs: { place: 'number2' } }, `${this.getMemberNum.usedNum + this.needBuyCount}/${this.getMemberNum.totalNum}`)
          ]
        })
      }, {
        condition: this.isEmailInvite && !this.sufficientSeatsAvailable && (this.hasUpgradePermission || this.hasSystemMemberEditPermission),
        component: createI18nComponent('saas.UserUpdateTips.desc9', {
          children: [
            h('span', { attrs: { place: 'number2' } }, this.getMemberNum.usedNum + this.needBuyCount - this.getMemberNum.totalNum),
            h('span', { attrs: { place: 'number1' } }, [
              h('b', {
                style: {
                  color: 'rgba(235, 69, 66)',
                  fontWeight: '400'
                }
              }, this.getMemberNum.usedNum + this.needBuyCount),
              '/' + this.getMemberNum.totalNum
            ]),
            h('span', { attrs: { place: 'number3' }, style: 'color: rgba(235, 69, 66);' }, this.getMemberNum.usedNum + this.needBuyCount - this.getMemberNum.totalNum)
          ]
        })
      }, {
        condition: this.isDirectAdd && this.sufficientSeatsAvailable && this.noSeatsAvailable && (this.hasUpgradePermission || this.hasSystemMemberEditPermission),
        component: createI18nComponent('saas.UserUpdateTips.desc13', {
          children: this.renderSeatInfo()
        })
      }, {
        condition: this.isDirectAdd && this.sufficientSeatsAvailable && !this.noSeatsAvailable && (this.hasUpgradePermission || this.hasSystemMemberEditPermission),
        component: createI18nComponent('saas.UserUpdateTips.desc10', {
          children: this.renderSeatInfo()
        })
      }, {
        condition: this.isDirectAdd && !this.sufficientSeatsAvailable && (this.hasUpgradePermission || this.hasSystemMemberEditPermission),
        component: createI18nComponent('saas.UserUpdateTips.desc11', {
          children: [
            h('span', { attrs: { place: 'number1' } }, this.needBuyCount),
            h('span', { attrs: { place: 'number2' }, style: 'color: rgba(235, 69, 66);' }, this.getMemberNum.usedNum + this.needBuyCount - this.getMemberNum.totalNum),
            h('span', { attrs: { place: 'number3' } }, `${this.getMemberNum.usedNum}/${this.getMemberNum.totalNum}`)
          ]
        })
      }, {
        condition: this.isOtherInvite && !this.noSeatsAvailable,
        component: createI18nComponent('saas.UserUpdateTips.desc7', {
          children: this.renderSeatInfo()
        })
      }, {
        condition: this.isOtherInvite && this.noSeatsAvailable && (this.hasUpgradePermission || this.hasSystemMemberEditPermission),
        component: createI18nComponent('saas.UserUpdateTips.desc3', {
          children:this.renderSeatInfo()
        })
      }];

      const item = cfg.find(item => item.condition);
      return item?.component;
    },
    // 无可用席位
    noSeatsAvailable() {
      return this.getMemberNum.usedNum >= this.getMemberNum.totalNum;
    },
    // 可用席位足够
    sufficientSeatsAvailable() {
      return this.getMemberNum.usedNum + this.needBuyCount <= this.getMemberNum.totalNum;
    }
  },
  mounted() {
    this.$store.dispatch('user/refreshProductRights', {
      force: true,
      token: this.$store.state.user.token
    });
  },
  methods: {
    handleRouterToBuy() {
      let params = null;
      /* eslint-disable */
                       
      params = {
        step: this.isFree ? 0 : 1,
        schemeId: this.userProductRights.productSchemeId
      }
              
                 
                                  
                                                     
                                                        
       
               
      /* eslint-disable */
      this.eventBus.$emit('global:openUpgradeDialog', params);
    },
    handleRouterToSetting() {
      window.open(resolveUrl(`${this.$config.VUE_APP_PMS_URL}/setting/members`), '_blank');
    },
    // 渲染席位信息
    renderSeatInfo() {
      const h = this.$createElement;
      return [
        h('span', { attrs: { place: 'number1' } }, this.getMemberNum.totalNum - this.getMemberNum.usedNum),
        h('span', { attrs: { place: 'number2' } }, `${this.getMemberNum.usedNum}/${this.getMemberNum.totalNum}`)
      ];
    }
  }
};
</script>

<style lang="scss">
@include b(user-update-tips) {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: var(--state-doing-bg);
  color: var(--state-doing-color-1);
  padding: 8px 30px;
  margin: 0px -32px;

  @include e(desc) {
    padding-inline-end: 24px;
    word-break: break-word;
  }
  @include e(btn) {
    &.el-button--primary.is-plain {
      background: var(--state-doing-bg);
    }
    & + & {
      margin-left: 16px;
    }
  }
  .btn-group {
    flex-shrink: 0;
  }
}
</style>
